<template>
  <v-sheet
    class="pr-2"
    elevation="1"
    :class="statusColorClass"
  >
    <v-card
      elevation="0"
      tile
    >
      <v-card-text>
        <v-row>
          <v-col class="flex-grow">
            <h4 class="my-2">
              {{ title }} <small v-if="subtitle && collapsed">{{ subtitle }}</small>
            </h4>
          </v-col>
          <v-col
            cols="auto"
          >
            <v-btn
              icon
              @click="collapsed = !collapsed"
            >
              <v-icon>
                {{ collapsableIcon }}
              </v-icon>
            </v-btn>
            <template v-if="peUserCanUpdate">
              <v-chip
                v-if="!viewOnly"
                class="ma-2"
                small
                :color="statusColorClass"
                outlined
              >
                {{ statusLabel }}
              </v-chip>
              <v-btn
                v-if="!viewOnly"
                color="primary"
                type="submit"
                small
                :disabled="!locked && invalid"
                @click="onAction"
              >
                {{ actionButtonText }}
              </v-btn>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
      <v-expand-transition>
        <v-card-text v-show="!collapsed">
          <slot />
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-sheet>
</template>

<script>
import { PARTY_NAMESPACE } from '@/store/party'
import { mapGetters } from 'vuex'

export default {
  name: 'GenericRow',

  props: {
    dirty: {
      type: Boolean,
      default: false,
    },

    invalid: {
      type: Boolean,
      default: false,
    },

    locked: {
      type: Boolean,
      default: false,
    },

    onAction: {
      type: Function,
      required: true,
    },

    subtitle: {
      type: String,
      default: null,
    },

    title: {
      type: String,
      required: true,
    },

    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      collapsed: false,
    }
  },

  computed: {
    actionButtonText () {
      return this.locked ? 'Unlock' : 'Update'
    },

    collapsableIcon () {
      return this.collapsed ? 'unfold_more' : 'unfold_less'
    },

    statusColorClass () {
      if (this.locked) return 'light-green'
      if (this.invalid) return 'red'
      if (this.dirty) return 'amber'

      return 'amber'
    },

    statusLabel () {
      if (this.locked) return 'locked'
      if (this.invalid) return 'invalid'
      if (this.dirty) return 'editing'

      return 'editing'
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peUserCanUpdate',
    ]),
  },
}
</script>
